import { useContext, useMemo } from 'react'
import type { WelcomeHookProps, WelcomeProps } from '../types'
import { ActivationObjectContext } from '../../providers/ActivationObjectProvider/constants'
import { useQueryClient } from 'react-query'

export const useWelcome = (props: WelcomeHookProps): WelcomeProps => {
    const { data, setGlobalAvatarMuted, setIsDocumentClicked } = useContext(
        ActivationObjectContext,
    )

    const queryClient = useQueryClient()

    const reactivationObjectStatus = queryClient.getQueryState([
        'activation-object',
    ])?.status

    const objectLoading = reactivationObjectStatus !== 'success'

    const handleStartWizard = () => {
        setIsDocumentClicked(true)
        setGlobalAvatarMuted(false)
    }

    const objectModifyLink = useMemo(
        (): string => `${process.env.REACT_APP_OBJECT_MODIFY}${data?.synonym}`,
        [data?.synonym],
    )

    return {
        handleStartWizard,
        objectModifyLink,
        objectInitLoading: objectLoading,
    }
}
